
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Badminton </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm badminton-series section-banner-bg-1">
    <div class="container">
        <div class="row ">
            <div class="sec-title text-center">
                <h2>Raisoni Badminton Super  <span > Series  </span></h2>
            </div>
            <div class="row">
                <div class="col-md-5 ">
                    <div class="image-effect-2">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton.webp"
                            alt="GHRSCF" class="w-100">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class=" text-justify">
                        <div class="widget_title inner-title">
                            <h4>RAISONI BADMINTON SUPER SERIES</h4>
                        </div>
                        <div class="fide-chess-text">
                            <p>"Sports is a preserver of health"</p>
                        </div>
                        <p>This is exactly the mindset behind the plethora of sports activities and competitions held at
                            the G H Rasioni College of Commerce, Science and Technology, Nagpur. A comprehensive
                            preparation is pursued at the part of the institute in the form of the best sports
                            instructor and amenities. And, then a number of competitions are held round the year to aid
                            the students in creating new milestones.</p>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="widget_title inner-title mt-3">
                    <h4>THE RAISONI BADMINTON SUPER SERIES IS EVERY BIT THE SAME.</h4>
                </div>
                <ul class="list-style list-style1">
                    <li>It is held once every year.</li>
                    <li>The event comprises of a number of leagues matches amongst the students.</li>

                </ul>

                <div class="fide-chess-text">
                    <p>The winners are then awarded Cash, Prizes and Trophy to encourage them.</p>
                </div>
            </div>
        </div>

    </div>
</section>
